import script from "./ManualJournal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManualJournal.vue?vue&type=script&setup=true&lang=ts"

import "./ManualJournal.vue?vue&type=style&index=0&id=91796e6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91796e6a"]])

export default __exports__